module.exports = __webpack_public_path__ + "static/img/plate_title_4.869a808.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/module/dataIndex/static/plate_title_4.png
// module id = yGXW
// module chunks = 60